module.exports = __webpack_public_path__ + "img/attached.f1d1f4ad.svg";